import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
// import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import HomePage from "./pages/home.jsx";
import PricingPage from "./pages/pricing.jsx";
import SignupPage from "./pages/signup.jsx";
import PartnerPage from "./pages/partners/partners.jsx";
import PrivacyPolicyPage from "./pages/privacypolicy.jsx";
import TermsPage from "./pages/terms.jsx";
import CaseStudy from "./pages/caseStudy";
import NotFoundPage from "./pages/notFoundPage.jsx";
import SolutionsPage from "./pages/solutions.jsx";

import "./styles/tailwind.css";
import "./styles/main.css";
import "./styles/Pablooflow.css";
import "./styles/hero-pablooprod/pablooprodFont.css";
import "./styles/hero-pablooprod/pablooprodStyle.css";

import reportWebVitals from "./reportWebVitals";
import TermsComponent from "./components/TermsComponent.js";
import { Login } from "./pages/login";
import Features from "./pages/features";
import ProductsPage from "./pages/products.jsx";
import ScheduleCall from "./pages/scheduleCall";
import {sendSlackMessage} from "./models/notifications";
import ForwardingPage from "./pages/ForwardingPage";
import StoreCreditApi from "./pages/storeCreditApi";
import PartnersJoin from "./pages/partners/join";
import Cart from "./pages/checkout/cart";
import CheckoutPage from "./pages/checkout/checkoutPage";
import OrderStatusPage from "./pages/checkout/orderStatusPage";
import PaymentPage from "./pages/checkout/paymentPage";
import CashbackProductPage from "./pages/products/cashbackProductPage";
import CashbackSolutionsPage from "./pages/solutions/cashbackSolutionsPage";
import MembershipsProductPage from "./pages/products/membershipsProductPage";
import StoreCreditRefundsProductPage from "./pages/products/storeCreditRefundsProductPage";


// Google Analytics
window.dataLayer = window.dataLayer || [];
window.gtag = function () {
  window.dataLayer.push(arguments);
};
window.gtag("js", new Date());
window.gtag("config", "G-RY13LC0YDT");

const TrackPageViews = () => {
  const location = useLocation();
  useEffect(() => {
    const pageTitle = getPageTitle(location.pathname);
    document.title = pageTitle;
    window.gtag("event", "page_view", {
      page_title: pageTitle,
      page_path: location.pathname,
    });
  }, [location]);
  return null;
};

if (process.env.NODE_ENV !== "development") {
  console.log = () => {}
}

const getPageTitle = (pathname) => {
  switch (pathname) {
    case "/":
      return "Pabloo | Home";
    case "/pricing":
      return "Pabloo | Pricing";
    case "/signup":
      return "Pabloo | Sign Up";
    case "/partners":
      return "Pabloo | Partnerships";
    case "/partners/join":
      return "Pabloo | Partnerships";
    case "/store-credit-api":
      return "Store Credit API | Pabloo";


    case "/privacy-policy":
      return "Pabloo | Privacy Policy";
    case "/terms-and-conditions":
      return "Pabloo | Terms and Conditions";
    case "/case-study":
      return "Pabloo | Case Study";
    case "/case-study/parks-project-study":
      return "Pabloo | Parks Project CaseStudy";
    case "/case-study/balodana-study":
      return "Pabloo | Balodana CaseStudy";
    case "/case-study/planted-material-study":
      return "Pabloo | Planted Materials CaseStudy";
    case "/case-study/stzy-study":
      return "Pabloo | Stzy CaseStudy";
    case "/login":
      return "Pabloo | Login";
    case "/thank-you":
      return "Pabloo | Purchase";
    case "/features":
      return "Pabloo | Features";


    case "/scheduleCall":
      return "Pabloo | Schedule Call";
    case "/us":  // Came from the newsletter - Tracked (us == Uncle Sam)
      return "Pabloo | Home";
    case "/forward*":
      return "Pabloo | Store Credit";

    //   Checkout pages
    case "/cart":
      return "Pabloo | Cart";
    case "/checkout":
      return "Pabloo | Checkout";
    case "/payment":
      return "Pabloo | Complete Payment";
    case "/status":
      return "Pabloo | Order Status";




    case "/products":
      return "Pabloo | Products";
    case "/products/cashback":
      return "Pabloo | Cashback Product";
    case "/products/memberships":
      return "Pabloo | Memberships Product";
    case "/products/store-credit-refunds":
      return "Pabloo | Store Credit Refunds Product";

    case "/solutions":
      return "Pabloo | Solutions";
    case "/solutions/cashback":
      return "Pabloo | Cashback Solutions";
    case "/solutions/memberships":
      return "Pabloo | Memberships Solutions";
    case "/solutions/store-credit-refunds":
      return "Pabloo | Store Credit Refunds Solutions";



    default:
      return "Not Found";
  }
};

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <Router>
      <TrackPageViews />
      <Routes>
        <Route path="/" rel="Home" element={<HomePage />} />
        <Route path="/us" rel="sam" element={
          <div>
            { sendSlackMessage("Uncle sam opened", "website-updates") }
            <HomePage />
          </div>
        } />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/partners" element={<PartnerPage />} />
        <Route path="/partners/join" element={<PartnersJoin />} />
        <Route path="/store-credit-api" element={<StoreCreditApi />} />

        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/case-study" element={<CaseStudy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/features" element={<Features />} />

        {/* PRODUCTS */}
        <Route path="/products" element={<CashbackProductPage />} />
        <Route path="/products/cashback" element={<CashbackProductPage />} />
        <Route path="/products/memberships" element={<MembershipsProductPage />} />
        <Route path="/products/store-credit-refunds" element={<StoreCreditRefundsProductPage />} />

        {/*Use a different url? cashback -> {problem} */}
        <Route path="/solutions" element={<CashbackSolutionsPage />} />
        <Route path="/solutions/cashback" element={<CashbackSolutionsPage />} />
        <Route path="/solutions/memberships" element={<CashbackSolutionsPage />} />
        <Route path="/solutions/store-credit-refunds" element={<CashbackSolutionsPage />} />


        <Route path="/scheduleCall" element={<ScheduleCall />} />

        <Route path="/forward*" element={<ForwardingPage />} />

        {/*Checkout pages */}
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/status" element={<OrderStatusPage />} />


        <Route path="*" element={<NotFoundPage />} />

        {/* For future pages added */}
        {/* <Route path="/" element={<HomePage/>}/>  */}
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
